import buildParams from './buildParams';

export default function(url, params = {}) {
  // https://www.contentful.com/blog/2017/12/08/change-of-the-contentful-asset-domain/
  if (
    !url ||
    (!url.includes('images.contentful.com') &&
      !url.includes('images.ctfassets.net')) ||
    url.includes('.svg')
  ) {
    return url;
  }

  const format = params.format || 'jpg';

  const query = buildParams({
    fm: format,
    fl: format === 'jpg' ? 'progressive' : null,
    q: format === 'jpg' && params.quality ? params.quality : null,
    w: params.width,
    h: params.height,
    fit: params.fit,
  });

  return `${url}${query}`;
}
